function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import SquareTagsGridComponent from "segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component";
import { buttonConfigByProduct, additionalText } from "../consts";
import { StyledProductTagsComponent } from "./product-tags-component.scss";
const ProductTagsComponent = (props)=>{
    var _currentTab_tabContent;
    const { currentTab, isV2, excludeFromWMHighIntentExperienceTest, translate } = props;
    const BUTTON_CONFIG_BY_PRODUCT = buttonConfigByProduct(isV2, excludeFromWMHighIntentExperienceTest);
    return /*#__PURE__*/ _jsx(StyledProductTagsComponent, {
        className: "product-tags-component",
        children: /*#__PURE__*/ _jsx(SquareTagsGridComponent, {
            clusters: currentTab === null || currentTab === void 0 ? void 0 : (_currentTab_tabContent = currentTab.tabContent) === null || _currentTab_tabContent === void 0 ? void 0 : _currentTab_tabContent.clusters,
            buttonConfig: _object_spread_props(_object_spread({}, BUTTON_CONFIG_BY_PRODUCT[currentTab === null || currentTab === void 0 ? void 0 : currentTab.productType]), {
                removeGradient: (currentTab === null || currentTab === void 0 ? void 0 : currentTab.productType) !== "work-management",
                additionalText: translate(additionalText[currentTab === null || currentTab === void 0 ? void 0 : currentTab.productType])
            }),
            showBorderInLightTheme: true,
            productType: currentTab === null || currentTab === void 0 ? void 0 : currentTab.productType
        })
    });
};
export default ProductTagsComponent;
